<template>
  <v-ons-page @show="initCrisp()">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Chatter avec Perfarmer</div>
    </v-ons-toolbar>

    <div class="content">
      <section v-if="! isChatLoaded" style="text-align: center; margin-top: 20px;">
        <v-ons-progress-circular :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </section>
    </div>

  </v-ons-page>
</template>

<script>

import { Crisp } from 'crisp-sdk-web';

export default {
  props: ['pageStack'],
  data() {
    return {
      isHelpdesk: false,
      articleId: '',
      isChatLoaded: false,
    }
  },  
  methods: {
    initCrisp() {
      Crisp.chat.onChatOpened(() => {
        this.isChatLoaded = true;
      });
      this.$showCrisp(Crisp, this.isHelpdesk, this.articleId);
    }
  }
};
</script>
